import React from "react";
import dynamic from "next/dynamic";
import { RFPFormBlock } from "../index";

// Dynamic imports
import Section from "@/Components/LayoutComponents/Section";
const QuoteForm = dynamic(() => import("./QuoteForm"), {
  ssr: false,
});

interface RFPFormProps {
  data?: RFPFormBlock;
}

const RFPForm: React.FC< RFPFormProps> = ({ data  }) =>  {
  return (
    <Section>
      <div className="container">
        <div className="max-w-[1230px] mx-auto text-center">
          <h2 className="text-heading-1 text-primary-text font-bold capitalize">
            {data?.title}
          </h2>
          <p className="text-subtitle-2 text-secondary-text font-regular mt-3 max-w-[1056px] mx-auto">
            {data?.sub_title}
          </p>
        </div>
        <div className="xl:mt-10 mt-8">
          <QuoteForm data={data} />
        </div>
      </div>
    </Section>
  );
};
export default RFPForm;
